import { tv } from "@/utils/tv.config";
import { VariantProps } from "tailwind-variants";

const selectClasses = tv({
  slots: {
    root: ["Select__root group flex w-full flex-col gap-1 relative mb-2"],
    trigger: [
      "flex",
      "h-10",
      "min-w-36",
      "items-center",
      "justify-between",
      "gap-3",
      "rounded-xl",
      "border",
      "border-gray-300",
      "pr-3",
      "pl-3.5",
      "text-sm",
      "bg-common-white",
      "text-gray-900",
      "select-none",
      "hover:bg-gray-100",
      "focus:outline-none",
      "focus:border-primary-main",
      "focus:ring-2",
      "focus:ring-primary-light/50",
      "active:bg-gray-200",
      "data-[popup-open]:bg-gray-100",
      "group-data-[invalid]:border-error-main",
      "group-data-[invalid]:focus-within:ring-error-main/50",
    ],
    popup: [
      "group",
      // "max-h-[var(--available-height)]",
      "origin-[var(--transform-origin)]",
      "overflow-y-auto",
      "rounded-xl",
      "bg-white",
      "py-1",
      "text-gray-900",
      "outline",
      "outline-1",
      "outline-gray-300",
      "transition-[transform,scale,opacity]",
      "data-[ending-style]:scale-y-90",
      "data-[ending-style]:opacity-90",
      "data-[ending-style]:transition-none",
      "data-[starting-style]:scale-y-90",
      "data-[starting-style]:opacity-0",
      "data-[side=none]:data-[starting-style]:scale-90",
      "data-[side=none]:data-[starting-style]:opacity-90",
      "data-[side=none]:data-[starting-style]:transition-none",
      "max-h-[300px] overflow-y-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]",
    ],
    scrollUp: [
      "top-0 z-[1] flex h-4 w-full cursor-default items-center justify-center rounded-md bg-white text-center text-xs before:absolute before:top-[-100%] before:left-0 before:h-full before:w-full before:content-[''] data-[direction=down]:bottom-0 data-[direction=down]:before:bottom-[-100%]",
    ],
    scrollDown: [
      "bottom-0 z-[1] flex h-4 w-full cursor-default items-center justify-center rounded-md bg-white text-center text-xs before:absolute before:top-[-100%] before:left-0 before:h-full before:w-full before:content-[''] data-[direction=down]:bottom-0 data-[direction=down]:before:bottom-[-100%]",
    ],
    positioner: ["outline-none"],
    icon: ["flex"],
  },
  variants: {
    colSpan: {
      1: {
        root: ["col-span-1"],
      },
      2: {
        root: ["col-span-1 sm:col-span-2"],
      },
      3: {
        root: ["col-span-1 sm:col-span-3"],
      },
      4: {
        root: ["col-span-1 sm:col-span-4"],
      },
      5: {
        root: ["col-span-1 sm:col-span-5"],
      },
      6: {
        root: ["col-span-1 sm:col-span-6"],
      },
    },
  },
});

export const {
  root: selectRootClasses,
  trigger: selectTriggerClasses,
  popup: selectPopupClasses,
  scrollUp: scrollUpClasses,
  scrollDown: scrollDownClasses,
  positioner: positionerClasses,
  icon: iconClasses,
} = selectClasses();

export type SelectVariants = VariantProps<typeof selectClasses>;
